import { useSelector } from 'react-redux';
import { PlaceEmployee } from '@/types/state/shared';
import { getAuthorInitials } from '../ProfilePages/helpers/review';
import Avatar from '@/components/elements/Avatar';
import Symbol from '@/components/elements/Symbol';

export const EmployeeReviewAvatar = ({
  employeeId,
  size,
}: {
  employeeId: number;
  size: 'xs' | 'sm' | 'md' | 'lg' | '56' | '60' | '64' | '72' | '80' | '96';
}) => {
  const employee = useSelector(
    (state: { employees: { all: Record<string, PlaceEmployee> } }) => state.employees.all[employeeId],
  );

  if (!employee) {
    return (
      <Symbol size={size} classNames={'rounded-full bg-white shadow text-fg_secondary'}>
        <span>{getAuthorInitials('')}</span>
      </Symbol>
    );
  }

  const { name, avatar } = employee.about || {};

  return avatar ? (
    <Avatar src={avatar} size={size} style={{ borderRadius: '100%', overflow: 'hidden' }} />
  ) : (
    <Symbol size={size} classNames={'rounded-full bg-white shadow text-fg_secondary'}>
      <span>{getAuthorInitials(name)}</span>
    </Symbol>
  );
};
